import { render, staticRenderFns } from "./Dialog_StudentCourseEvaluation.vue?vue&type=template&id=07d1d4b8&scoped=true&"
import script from "./Dialog_StudentCourseEvaluation.vue?vue&type=script&lang=js&"
export * from "./Dialog_StudentCourseEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d1d4b8",
  null
  
)

export default component.exports